/** @format */

import React from "react";
import { Link } from "react-router-dom";
/**
 *
 *  @params none
 *
 * This component returns a button that allows the user to navigate from Compliance Local Outreach to Activities App.
 */

const RedirectActivities = ({ user }) => {  

  return (
    <span>
      <i className="fal fa-file-magnifying-glass mr-2 text-primary pl-1"></i>
      <a
        href={process.env.REACT_APP_ACTIVITIES_FRONTEND}
        className="redirect-activities text-primary"
        type="button"
        id="redirectActivities"
      >
        View Activities
      </a>
    </span>
  );
};

export default RedirectActivities;
